import React, { useRef, useState } from "react"
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'
import { v4 as uuidv4 } from 'uuid'
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { CallData,EmbeddedGetEmbeddedRecognition,EmbeddedSetEmbeddedRecognition,EmbeddedGetEmbeddedRecognitionSelectedIndex,EmbeddedSetEmbeddedRecognitionSelectedIndex } from "../EmbeddedSupport.jsx"
import { EmbeddedZohoGetLastInsertedCallId,EmbeddedZohoSetLastInsertedCallId,EmbeddedZohoGetLastInsertedZohoCallId,EmbeddedZohoSetLastInsertedZohoCallId,
  EmbeddedZohoGetSettingAutoCreateCall,EmbeddedZohoGetSettingAutoOpenMatch,EmbeddedZohoGetSettingAutoCreateMatch, EmbeddedZohoGetSettingDefaultInboundCallSubject,
  EmbeddedZohoGetSettingDefaultOutboundCallSubject,EmbeddedZohoGetLastAutoOpenMatch,EmbeddedZohoSetLastAutoOpenMatch,EmbeddedZohoGetLastAutoCreateMatch,
  EmbeddedZohoSetLastAutoCreateMatch } from "./EmbeddedZohoSupport.jsx"
import Embedded from "../Embedded.jsx"
import { Translate } from "../../Components/Translator.jsx"
import { IsEmptyString, TimeDifferenceInMinutesAndSeconds, GetBrandButtonClass, explode } from "../../Components/GeneralFunctions.jsx"

import CompanyPng from '../Assets/embedded_company.png'
import ContactPng from '../Assets/embedded_contact.png'
import CreateCallPng from '../Assets/zoho_createcall.png'
import CreateContactPng from '../Assets/embedded_createcontact.png'
import OpenCallPng from '../Assets/zoho_opencall.png'

const EmbeddedZoho = (props) => {

  const cEntities = [
    {type: "Contacts",  idField: "id",  phoneField: "Phone",  nameField: "Full_Name",     nameFieldCreate: "Last_Name"},
    {type: "Accounts",  idField: "id",  phoneField: "Phone",  nameField: "Account_Name",  nameFieldCreate: "Account_Name"},
    {type: "Leads",     idField: "id",  phoneField: "Phone",  nameField: "Full_Name",     nameFieldCreate: "Last_Name"}
  ]

  const cCallPurposes = [
    "-None-",
    "Prospecting",
    "Administrative",
    "Negotiation",
    "Demo",
    "Project",
    "Support"
  ]
  
  const [mRepainter, SetRepainter] = useState("")  
  const [mZohoInitialized, SetZohoInitialized] = useState(false) //'ZOHO' object from the SDK is used as the main Zoho Embedded object

  const [mCallNote, SetCallNote] = useState("") //Local textbox content of the callnote field 
  const [mCallPurpose, SetCallPurpose] = useState(cCallPurposes[0]) //Local textbox content of the callpurpose field. Only used for outbound calls
   
  //ZOHO API

  const ZohoAPI_CreateCall = async (callData) => 
  {
    const EmbeddedRecognition = EmbeddedGetEmbeddedRecognition()
    const EmbeddedRecognitionSelectedIndex = EmbeddedGetEmbeddedRecognitionSelectedIndex()
    const SelectedRecognition = (EmbeddedRecognition != null) && (EmbeddedRecognition.length > EmbeddedRecognitionSelectedIndex) ? EmbeddedRecognition[EmbeddedRecognitionSelectedIndex] : null

    const isoTime = new Date(callData.starttime).toISOString()
    const modifiedDateTime = isoTime.substring(0, isoTime.lastIndexOf(".")) + "Z"     
    const callDuration = (callData.endedtime != null && callData.answeredtime != null) ? Math.round((callData.endedtime - callData.answeredtime) / 1000) : 0
    const name = (SelectedRecognition != null) ? ZohoGetContactDisplayName(SelectedRecognition) : callData.opn
    
    let subject = callData.inbound ? EmbeddedZohoGetSettingDefaultInboundCallSubject() : EmbeddedZohoGetSettingDefaultOutboundCallSubject()      
    subject = subject.replaceAll("<callid>",callData.id)
    subject = subject.replaceAll("<number>",callData.opn)
    subject = subject.replaceAll("<name>",name)
    subject = subject.replaceAll("<extension>",callData.extension)
    subject = subject.replaceAll("<ddi>",callData.ddi)
    subject = subject.replaceAll("<ddiname>",callData.ddiname)
    subject = subject.replaceAll("<callstart>",modifiedDateTime)
    subject = subject.replaceAll("<calltime>",TimeDifferenceInMinutesAndSeconds(callData.endedtime - callData.starttime))
    subject = subject.replaceAll("<talktime>",TimeDifferenceInMinutesAndSeconds(callData.endedtime - callData.answeredtime))

    let apiData = {
        Subject: subject,
        Call_Type: (callData.endedtime != null) && (callData.answeredtime == null) && callData.inbound ? "Missed" : (callData.inbound ? "Inbound" : "Outbound"),
        Call_Start_Time: modifiedDateTime,
        Call_Duration: callDuration.toString(),
        ...(!callData.inbound) && {Call_Purpose: cCallPurposes[0]},
        ...(callData.state.toLowerCase() === "ended") && {Call_Result: callData.answeredtime == null ? "No_response/Busy" : "-None-"}, // Only set Call_Result if call has ended
        
        Phone: callData.opn
        // Owner: { id: this._currentUserID } //24-8-2020: manually add userID to hopefully fix issues customer should work without this info
    }

    if (SelectedRecognition != null) 
    {
        if (SelectedRecognition.type == "Contacts")
        {
          apiData["Who_Id"] = SelectedRecognition.id
        }
        else 
        {
          apiData["$se_module"] = SelectedRecognition.type
          apiData["What_Id"] = { name: SelectedRecognition.name, id: SelectedRecognition.id }
        }
    }
    else
    {
        apiData["$se_module"] = "Calls"
    }
    console.log("Call registering",apiData)
    ZOHO.CRM.API.insertRecord({ Entity: "Calls", APIData: apiData })
        .then(async (insertRecordData) => {
            console.log("Call registered successfully",insertRecordData)
            const ZohoCallId = insertRecordData.data[0].details.id
            EmbeddedZohoSetLastInsertedCallId(callData.id)
            EmbeddedZohoSetLastInsertedZohoCallId(ZohoCallId)
            //ZohoAPI_OpenItem(ZohoCallId, "Calls") 
            SetRepainter(uuidv4())
        }).catch((error) => {
            console.error("Error saving call: ", error)
        })
  }

  const ZohoAPI_CreateCallNote = async (zohocallid) => 
  {
    ZOHO.CRM.API.addNotes({ Entity: "Calls", RecordID: zohocallid, Content: mCallNote })
        .then((addNoteData) => {
            const ZohoCallNoteId = addNoteData.data[0].details.id
            console.log("Added call note", ZohoCallNoteId)
            SetCallNote("")
            SetRepainter(uuidv4())
        }).catch((error) => {
            console.error("Error saving callnote: ", error)
        })
  }

  const ZohoAPI_CreateContact = async (callNumber) => 
  {
    const defaultName = "Caller " + callNumber
    const apiData = { Phone: callNumber, Last_Name: defaultName }

    ZOHO.CRM.API.insertRecord({ Entity: "Contacts", APIData: apiData })
        .then((insertRecordData) => {
            let recognitions = EmbeddedGetEmbeddedRecognition() ?? []
            const recordId = insertRecordData.data[0].details.id
            recognitions.push({name: defaultName, type: "Contacts", id: recordId, phone: callNumber})
            EmbeddedSetEmbeddedRecognition(JSON.stringify(recognitions))
            EmbeddedSetEmbeddedRecognitionSelectedIndex(recognitions.length - 1)

            SetRepainter(uuidv4())
            ZohoAPI_OpenItem(recordId, "Contacts")
        })
        .catch((error) => {
            console.error("Failed to create new contact", error);
            toast.error("Failed to create new contact")

            return null
        })
  }

  const ZohoAPI_OpenItem = (id,type) => 
  {
    try
    {
      ZOHO.CRM.UI.Record.open({ Entity: type, RecordID: id})
    }
    catch(error)
    {
      console.log("ZohoAPI_OpenItem error",error)
    }
  }

  const ZohoAPI_SearchEntities = async (results, entity, phoneLast8Digits) =>
  {
    const selectQuery = { "select_query": "select " + entity["nameField"] + ", " + entity["phoneField"] + ", " + entity["idField"] + " from " + entity["type"] + " where " + entity["phoneField"] + " like '%" + phoneLast8Digits + "'"}
    console.log("lookup query", entity["type"], selectQuery)
    const queryResult = await ZOHO.CRM.API.coql(selectQuery)
    console.log("lookup result", entity["type"], queryResult)

    if ((queryResult?.data != null) && (queryResult.data.length > 0)) 
    {
        queryResult.data.map((item) => {
            if ((item != null) && (item.Phone != null) && (item.Phone.replace(/\D/g,'').slice(-8) == phoneLast8Digits)) //Extra check in edge cases where the last 8 digits were found, but not at the end
            {
                results.push({ name: item[entity["nameField"]], type: entity["type"], id: item[entity["idField"]], phone: item[entity["phoneField"]] });
            }
        })
    }
  }

  const ZohoAPI_UpdateCall = async (apidata) =>
  {
        ZOHO.CRM.API.updateRecord({ Entity: "Calls", APIData: apidata }) 
        .then((updateRecordData) => {
            console.log("Call updated successfully")
        }).catch((error) => {
            console.error("Error updating call: ", error)
        })
  }

  //END OF ZOHO API 

  const EmbeddedZohoSearchResult = (name, type, id, phone) => {
    return {
      name: name,
      type: type,
      id: id,
      phone: phone
    }
  }

  const NewCallState = (calldata,contacts) =>
  {
    if (props.PrimaryTab)
    {
      TryAutomaticActions(calldata,contacts ?? EmbeddedGetEmbeddedRecognition())

      //Update zoho call with every event
      const CallId = EmbeddedZohoGetLastInsertedCallId()
      const ZohoCallId = EmbeddedZohoGetLastInsertedZohoCallId()
      if ((CallId === calldata.id) && !IsEmptyString(ZohoCallId))
      {
        //This is a new event for a call that has already been added
        if (calldata.state === "ended")
        {
          const callDuration = calldata.answeredtime != null ? Math.round((calldata.endedtime - calldata.answeredtime) / 1000) : 0
          const updateApiData = {
            id: ZohoCallId,
            Call_Duration: callDuration.toString(),
            Call_Result: callData.answeredtime == null ? "No_response/Busy" : "-None-"} // Only set Call_Result if call has ended
        }
        ZohoAPI_UpdateCall(updateApiData)
      }
    }
  }

  const TryAutomaticActions = (calldata,contacts) =>
  {
    console.log("TryAutomaticActions",calldata,contacts)

    //Automatic action: create call
    const settingautocreatecall = EmbeddedZohoGetSettingAutoCreateCall() === "yes"
    if (settingautocreatecall)
    {
      const CallId = EmbeddedZohoGetLastInsertedCallId()
      if (CallId !== calldata.id)
      {
        ZohoAPI_CreateCall(calldata)
      }
    }
        
    //Automatic action: pop single-match
    const settingautoopenmatch = EmbeddedZohoGetSettingAutoOpenMatch()
    if ((contacts != null) && (contacts.length === 1) &&
      ((settingautoopenmatch === "started") || ((settingautoopenmatch === "answered") && (calldata.state === "answered"))))
    {
      console.log("TryAutomaticActions settingautoopenmatch2")
      const LastAutoOpenMatch = EmbeddedZohoGetLastAutoOpenMatch()
      EmbeddedZohoSetLastAutoOpenMatch(calldata.id)
      if (LastAutoOpenMatch !== calldata.id)
      {
        ZohoAPI_OpenItem(contacts[0].id, contacts[0].type)
      }
    }

    //Automatic action: create contact when no match is found
    const settingautocreatematch = EmbeddedZohoGetSettingAutoCreateMatch() 
    if ((contacts != null) && (contacts.length === 0) &&
      ((settingautocreatematch === "started") || ((settingautocreatematch === "answered") && (calldata.state === "answered"))))
    {
      const LastAutoCreateMatch = EmbeddedZohoGetLastAutoCreateMatch()
      EmbeddedZohoSetLastAutoCreateMatch(calldata.id)
      if (LastAutoCreateMatch !== calldata.id)
      {
        ZohoAPI_CreateContact(calldata.opn)
      }
    }    
  }

  const ZohoCreateEntity = async (number,type) =>
  {
    return await ZohoAPI_CreateContact(number)
  }

  const ZohoGetAdditionalCallActions = (calldata) =>
  {
    const lastInsertedCallId = EmbeddedZohoGetLastInsertedCallId()
    const lastInsertedZohoCallId = EmbeddedZohoGetLastInsertedZohoCallId()
    const embeddedRecognition = EmbeddedGetEmbeddedRecognition()

    const CreateContactAction = <img className="clickable" src={CreateContactPng} title={Translate("Create and show contact")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => ZohoAPI_CreateContact(calldata.opn)}/>
    const CreateCallAction = <img className="clickable" src={CreateCallPng} title={Translate("Add call to Zoho")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => ZohoAPI_CreateCall(calldata)}/>
    const OpenCallAction = <img className="clickable" src={OpenCallPng} title={Translate("Show call")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => ZohoAPI_OpenItem(lastInsertedZohoCallId,"Calls")}/>

    return <>
      {(embeddedRecognition != null) && (embeddedRecognition.length === 0) ? <>&nbsp;{CreateContactAction}</> : <></>}
      {(lastInsertedCallId != calldata.id) ? <>&nbsp;{CreateCallAction}</> : <>&nbsp;{OpenCallAction}</>}
    </>  
  }

  const ZohoGetAdditionalCallInfoNode = (calldata) =>
  {
    const lastInsertedCallId = EmbeddedZohoGetLastInsertedCallId()
    if (!IsEmptyString(calldata.id) && (lastInsertedCallId === calldata.id))
    {
      const lastInsertedZohoCallId = EmbeddedZohoGetLastInsertedZohoCallId()
      return <>
        { calldata.inbound ? <></> : <div style={{ marginBottom: '2px' }}>
                <b>Call Purpose</b>
                <select style={{ width: '100%', padding: '6px' }} value={mCallPurpose} onChange={(event) => {
                    ZohoUpdateCallPurpose(event.target.value)
                }}>
                {cCallPurposes.map((callPurpose) => <option style={{ padding: '6px' }} value={callPurpose} key={callPurpose}>{callPurpose}</option>)}
                </select>
            </div>
        }
        <textarea style={{ width: '100%', flex: '1', padding: '6px', marginTop: '4px', resize: 'none' }} value={mCallNote} placeholder={Translate("Note")} onChange={(evt) => { SetCallNote(evt.target.value); }}/> 
        <Button variant="info" className={GetBrandButtonClass(props.Brand)} style={{ width: '100%' }} onClick={() => ZohoAPI_CreateCallNote(lastInsertedZohoCallId)}>{Translate("Add call note")}</Button>
      </>
    }
    else
    {
      return <></>
    }
  }

  const ZohoGetContactDisplayName = (contact) =>
  {
    return contact.name
  }

  const ZohoGetContactIcon = (contact) =>
  {
    return contact.type === cEntities[0]["type"] ? ContactPng : 
      (contact.type === cEntities[1]["type"] ? CompanyPng : 
      (contact.type === cEntities[2]["type"] ? ContactPng : ""))
  }

  const ZohoInitialize = () => 
  {
    const script = document.createElement('script')
    script.src = 'https://live.zwidgets.com/js-sdk/1.5/ZohoEmbededAppSDK.min.js'
    script.type = "text/javascript"
    script.async = true
    script.onload  = () => {
        if (typeof ZOHO !== 'undefined')
        {
            ZOHO.embeddedApp.on("Dial",function(data){
                console.log("Number Dialed",data);
            })

            ZOHO.embeddedApp.on("PageLoad",function(data){
                console.log("Zoho embedded app initialized from PageLoad")
                ZOHO.CRM.UI.Resize({height:"493",width:"348"})
                SetZohoInitialized(true)
            })

            ZOHO.embeddedApp.init()
        }
        else
        {
            toast.error("Failed to load Zoho SDK object")
        }
    }
    script.onerror = () => toast.error("Failed to load Zoho SDK file")
    document.head.appendChild(script)
  } 

  const ZohoNewCallEvent = (calldata,contacts) =>
  {
    EmbeddedZohoSetLastInsertedCallId("")
    EmbeddedZohoSetLastInsertedZohoCallId("")
    SetCallPurpose(cCallPurposes[0])
    SetCallNote("")

    try { ZOHO.CRM.UI.Dialer.maximize() } catch(error) { console.log("ZOHO.CRM.UI.Dialer.maximize failed",error)} //Open widget
    if (props.PrimaryTab && calldata.inbound)
    {
      try { ZOHO.CRM.UI.Dialer.notify() } catch(error) { console.log("ZOHO.CRM.UI.Dialer.maximize failed",error)} //Sound notification
    }

    NewCallState(calldata,contacts)
  }

  const ZohoNewCallStateEvent = (calldata) =>
  {
    if (props.PrimaryTab)
    {
      NewCallState(calldata,null)
    }
  }

  const ZohoOpenCall = async (zohocall) =>
  {
    return await ZohoAPI_CreateCall(calldata)
  }

  const ZohoOpenContact = (contact) => 
  {
    ZohoAPI_OpenItem(contact.id, contact.type)
  }

  const ZohoScreenpopUrlCreate = (contact) => 
  {
    return "embedded://zoho." + contact.id + "." + contact.type
  }
  
  const ZohoScreenpopUrlExecute = (url) => 
  {
    const prefix = "embedded://";
    if (!url.startsWith(prefix)) 
    {
      //This is a regular script, perhaps created earlier
      OpenPopup(url)
    }
    else
    {
      const parts = url.slice(prefix.length).split(".");
      if (parts.length > 0) 
      {
        if (parts[0] === "zoho")
        {
          if (parts.length === 3)
          {             
            ZohoAPI_OpenItem(parts[1],parts[2])
          }
          else
          {
            console.log("Invalid popup value: " + aUrl)
          }
        }
        else
        {
          console.log("Zoho Embedded cannot execute scripts for embedded " + parts[0])
        }
      }
      else
      {
        console.log("Empty popup value")
      }
    }
  }

  const ZohoSearchContacts = async (number) => 
  {
    let RecognitionBuffer = []
    try 
    {
        const phoneLast8Digits = number.replace(/\D/g,'').slice(-8)   

        //cEntities.map() gives async errors
        await ZohoAPI_SearchEntities(RecognitionBuffer, cEntities[0], phoneLast8Digits)
        await ZohoAPI_SearchEntities(RecognitionBuffer, cEntities[1], phoneLast8Digits)
        await ZohoAPI_SearchEntities(RecognitionBuffer, cEntities[2], phoneLast8Digits) 
    } 
    catch (error) 
    {
        console.error("Failed to parse phone number: ", error.message);
    }
    console.log("ZohoSearchContacts response", RecognitionBuffer)
    return RecognitionBuffer
  }  

  const ZohoUpdateCallPurpose = (value) =>
  {
    SetCallPurpose(value)

    const ZohoCallId = EmbeddedZohoGetLastInsertedZohoCallId()
    const updateApiData = {
            id: ZohoCallId,
            Call_Purpose: value    
    }
    ZohoAPI_UpdateCall(updateApiData)
  }

  return <Embedded 
    Calls={props.Calls}
    SecurityToken={props.SecurityToken}
    PhoneApiError={props.PhoneApiError}
    LastCallEventId={props.LastCallEventId}
    Brand={props.Brand}
    RecognitionCacheQueryingNumbers={props.RecognitionCacheQueryingNumbers}
    SpeedDials={props.SpeedDials}
    PrimaryTab={props.PrimaryTab}
    OnAddToSpeedDial={props.OnAddToSpeedDial}
    OnClearCall={props.OnClearCall}
    OnMakeCall={props.OnMakeCall}
    OnRemoveFromCallHistory={props.OnRemoveFromCallHistory}
    OnRemoveFromSpeedDial={props.OnRemoveFromSpeedDial}
    OnSetHistoryCallRecognition={props.OnSetHistoryCallRecognition}

    Crm="Zoho"
    OnCreateContact={(number,type) => ZohoCreateEntity(number,type)}
    OnGetAdditionalCallActions={(calldata,) => ZohoGetAdditionalCallActions(calldata)}
    OnGetAdditionalCallInfoNode={(calldata,) => ZohoGetAdditionalCallInfoNode(calldata)}
    OnGetContactDisplayName={(contact,) => ZohoGetContactDisplayName(contact)}
    OnGetContactIcon={(contact,) => ZohoGetContactIcon(contact)}
    OnInitialize={() => ZohoInitialize()}
    OnNewCallEvent={(calldata,contacts) => ZohoNewCallEvent(calldata,contacts)}
    OnNewCallStateEvent={(calldata) => ZohoNewCallStateEvent(calldata)}
    OnOpenContact={(contact) => ZohoOpenContact(contact)}
    OnScreenpopUrlCreate={(contact) => ZohoScreenpopUrlCreate(contact)}
    OnScreenpopUrlExecute={(url) => ZohoScreenpopUrlExecute(url)}
    OnSearchContacts={(number) => ZohoSearchContacts(number)}/>
}

EmbeddedZoho.propTypes = {
  Calls: PropTypes.array,
  SecurityToken: PropTypes.string,
  PhoneApiError: PropTypes.string,
  LastCallEventId: PropTypes.string, //used for repainting purposes. updates on call event
  Brand: PropTypes.string,
  RecognitionCacheQueryingNumbers: PropTypes.array,
  SpeedDials: PropTypes.array,
  PrimaryTab: PropTypes.bool,
  OnAddToSpeedDial: PropTypes.func,
  OnClearCall: PropTypes.func,
  OnMakeCall: PropTypes.func,
  OnRemoveFromCallHistory: PropTypes.func,
  OnRemoveFromSpeedDial: PropTypes.func,
  OnSetHistoryCallRecognition: PropTypes.func
}

export default EmbeddedZoho